var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { Box, Grid, Typography } from '@mui/material';
import { offerList as api } from '../../api';
import { useSampleOrderColumns } from '../../hooks/useColumns';
import { useFetchSampleOrders } from '../../hooks/useSampleOrder';
import { useRequest } from '../../hooks/requestHook';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import AdminNewOrderButton from '../organisms/AdminNewOrderButton';
import { useRoasterCountries } from '../../hooks/useRoasterCountries';
import { useOffice } from '../../hooks/useOffice';
import DownloadSampleOrdersCSVButton from '../organisms/DownloadSampleOrdersCSVButton';
import ImportSampleOrdersButton from '../organisms/ImportSampleOrdersButton';
var Toolbox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  a {\n    color: #666;\n  }\n\n  button {\n    margin-left: 5px;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  a {\n    color: #666;\n  }\n\n  button {\n    margin-left: 5px;\n  }\n"])));
var AdminOfferListSampleOrdersPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var location = useLocation();
    var t = useTranslation().t;
    var roasterCountryItems = useRoasterCountries().roasterCountryItems;
    var officeItems = useOffice().officeItems;
    var _b = React.useState(), offerList = _b[0], setOfferList = _b[1];
    var getOfferList = useRequest(api.get);
    var fetchSampleOrders = useFetchSampleOrders({
        offerListId: id,
        type: 'SampleOrder::DirectSampleOrder',
    }).fetchSampleOrders;
    var query = qs.parse(location.search.slice(1));
    var tableRef = React.useRef();
    var reload = React.useCallback(function () {
        if (!tableRef.current)
            return;
        tableRef.current.onQueryChange();
    }, [tableRef]);
    var SampleOrderColumns = useSampleOrderColumns({
        role: 'admin',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var defaultFilter = React.useCallback(function (field) {
        var filters = query.filters || {};
        return filters[field];
    }, [query]);
    var renderRoasterCountry = React.useCallback(function (sampleOrder) {
        var code = sampleOrder.roaster.country.code;
        return roasterCountryItems[code];
    }, [roasterCountryItems]);
    var renderRoasterCountryOffice = React.useCallback(function (sampleOrder) {
        var name = sampleOrder.roaster.country.office.name;
        return name;
    }, []);
    var columns = React.useMemo(function () { return [
        SampleOrderColumns.roasterName,
        SampleOrderColumns.storeName,
        SampleOrderColumns.personName,
        {
            field: 'roaster.country.code',
            title: t('params.roaster.country'),
            lookup: roasterCountryItems,
            render: renderRoasterCountry,
            defaultFilter: defaultFilter('roaster.country.code'),
            sorting: false,
        },
        {
            field: 'roaster.country.office.name',
            title: t('params.office.name'),
            lookup: officeItems,
            render: renderRoasterCountryOffice,
            defaultFilter: defaultFilter('roaster.country.office.name'),
            sorting: false,
        },
        SampleOrderColumns.email,
        SampleOrderColumns.status,
        SampleOrderColumns.deliveryCompany,
        SampleOrderColumns.trackingNumber,
        SampleOrderColumns.createdAt,
    ]; }, [
        SampleOrderColumns,
        officeItems,
        defaultFilter,
        renderRoasterCountry,
        roasterCountryItems,
        renderRoasterCountryOffice,
        t,
    ]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getOfferList({ id: id })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        if (!response)
                            return [2 /*return*/];
                        setOfferList(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, setOfferList, getOfferList]);
    return (React.createElement(PageLayout, { backLink: true, backLinkTo: "/admin/sample_ordered_offer_lists", title: t('pages.sampleOrders.title'), actions: React.createElement(AdminNewOrderButton, { offerList: offerList }) },
        React.createElement(Box, { px: 1, py: 2 }, offerList && (React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('params.offerList.name'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(Typography, { variant: "body2" }, offerList.name)),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('labels.curatorName'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(Typography, { variant: "body2" }, "".concat(offerList.producer.firstname, " ").concat(offerList.producer.lastname, " (").concat(t("countries.".concat(offerList.producer.country)), ")")))))),
        React.createElement(Toolbox, null,
            React.createElement(DownloadSampleOrdersCSVButton, { offerListId: id, type: "SampleOrder::DirectSampleOrder" }),
            React.createElement(ImportSampleOrdersButton, { onComplete: reload })),
        React.createElement(MaterialTable, { tableRef: tableRef, model: "sampleOrder", columns: columns, data: fetchSampleOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
                filtering: true,
            }, detailPath: function (sampleOrder) { return "/admin/sample_orders/".concat(sampleOrder.id); } })));
};
export default AdminOfferListSampleOrdersPage;
var templateObject_1;
